module.exports = __webpack_public_path__ + "img/twitter.1c56c841.png";